module.exports = __webpack_public_path__ + "media/images/company-logos/company-logos-desktop-ac7f1c7bdd76ed2ba71a1c894859538f.jpg";